"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var DataDictionaryError_1 = require("../core/model/data-dictionary/DataDictionaryError");

var utils_1 = require("../core/utils");

var KpiRecord_1 = require("./KpiRecord");

var KpiRecordConverter_1 = require("./KpiRecordConverter");
/**
 *
 * @author Stepan Mik
 */


var KpiRecordConverterImpl =
/*#__PURE__*/
function (_KpiRecordConverter_) {
  _inherits(KpiRecordConverterImpl, _KpiRecordConverter_);

  function KpiRecordConverterImpl() {
    _classCallCheck(this, KpiRecordConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(KpiRecordConverterImpl).apply(this, arguments));
  }

  _createClass(KpiRecordConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      var values = immutable_1.Map();
      var fractions = immutable_1.Map();
      var kpis = source.values;

      if (kpis) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = Object.getOwnPropertyNames(kpis)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var kpi = _step.value;
            var kpiObj = kpis[kpi];

            if (!utils_1.Utils.isObject(kpiObj)) {
              throw new DataDictionaryError_1.DataDictionaryError('Expected object with KPI triplet');
            }

            values = values.set(kpi, conversions.toBigNumber(kpiObj['value']));
            fractions = fractions.set(kpi, [conversions.toBigNumber(kpiObj['nom']), conversions.toBigNumber(kpiObj['denom'])]);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }

      return new KpiRecord_1.KpiRecord(utils_1.Utils.assertDefined(conversions.toClassReferenceId(source.kpiId)), utils_1.Utils.asBool(source.aggregate), conversions.asObjectList(source, 'parentIds', function (value) {
        if (utils_1.Utils.isValueMissing(value)) {
          throw new DataDictionaryError_1.DataDictionaryError("parent id can no be empty!");
        }

        return conversions.toClassReferenceId(value);
      }), utils_1.Utils.asNumber(source.childCount), values, fractions);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var document = {
        kpiId: conversions.toDocumentReferenceId(source.kpiId),
        aggregate: source.aggregate,
        childCount: source.childCount,
        parentIds: source.parentIds.toArray().map(function (id) {
          return conversions.toDocumentReferenceId(id);
        }),
        values: {}
      };
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = source.values.keys()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var kpi = _step2.value;
          document.values[kpi] = {
            value: conversions.fromBigNumber(source.values.get(kpi)),
            nom: conversions.fromBigNumber(source.fractions.get(kpi)[0]),
            denom: conversions.fromBigNumber(source.fractions.get(kpi)[1])
          };
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return document;
    }
  }]);

  return KpiRecordConverterImpl;
}(KpiRecordConverter_1.KpiRecordConverter);

exports.KpiRecordConverterImpl = KpiRecordConverterImpl;